<template>
  <v-container class="booking-detail p-0" v-if="booking">
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>

    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="$t('booking_detail.title')">
      <v-container class="booking-detail-content" fluid>
        <v-row>
          <v-col order="2" cols="12"
                 order-md="1" md="6">
            <v-row>
              <v-col>
                <v-text-field :label="$t('booking.reference_number')"
                              readonly
                              hide-details
                              :value="referenceNumberLabel"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('booking.reserved_at')"
                              readonly
                              hide-details
                              :value="reservedAtLabel"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
<!--                <v-text-field :label="$t('booking.facility')"-->
<!--                              readonly-->
<!--                              hide-details-->
<!--                              :value="facilityLabel">-->
<!--                  <label>{{ facilityLabel }}</label>-->
<!--                </v-text-field>-->
                <v-textarea :label="$t('booking.facility')"
                            readonly
                            hide-details
                            :value="facilityLabel"
                            rows="1"
                            auto-grow
                            no-resize></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="booking.additional_items.length > 0">
              <v-col>
                <v-textarea :label="$t('booking_confirm.additional_items')"
                            readonly
                            hide-details
                            :value="booking.additional_items.map((i)=> `${i.type.name} x ${i.count}`).join('\n')"
                            rows="1"
                            auto-grow
                            no-resize></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('booking.fee')"
                              readonly
                              hide-details
                              :value="priceLabel"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('booking.second_contact_number')"
                              readonly
                              hide-details
                              :value="booking.booking_record.second_contact_number"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field :label="$t('booking.status')"
                              readonly
                              hide-details
                              :value="statusLabel"></v-text-field>
              </v-col>
            </v-row>

          </v-col>
          <v-col order="1" cols="12"
                 order-md="2" md="6"
                 class="text-md-right">
            <qrcode :value="booking.jwt" :options="{ width: '10rem' }" class="account-info-membership-big-qrcode"></qrcode>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left">
            <v-btn color="primary"
                   @click="$router.back()">
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>

      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "../../../constants";
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";

library.add(faChevronCircleLeft);

export default {
  name: 'BookingDetail',
  components: {HkiaraceBannerFrame},
  data() {
    return {
      bookingId: this.$route.params.bookingRecordId,
      booking: null,

      BOOKING_STATUS: BOOKING_STATUS,
    };
  },
  mounted() {
    this.getBooking();
  },
  computed: {
    facilityType() {
      return this.booking ? this.booking.item.type : null;
    },
    referenceNumberLabel() {
      return (this.booking && this.booking.reference_number) ? "BV" + this.booking.reference_number.toString().padStart(10, '0') : '';
    },
    reservedAtLabel() {
      return this.booking ? DateTime.fromISO(this.booking.create_at).toFormat('yyyy-MM-dd HH:mm') : '';
    },
    facilityLabel() {
      return DateTime.fromISO(this.booking.start_time).toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(this.booking.end_time).toFormat('HH:mm') + "  " + this.booking.item.name;

      // return this.bookingRecord ? this.bookingRecord.bookings.map(function (b) {
      //     return DateTime.fromISO(b.start_time).toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(b.end_time).toFormat('HH:mm') + "  " + b.item.name;
      // }).join("<br>") : "";
    },
    // couponLabel() {
    //     if (this.bookingRecord.used_coupons.length) {
    //         return this.bookingRecord.used_coupons.map(function (c) {
    //             return "$" + c.amount + " - " + DateTime.fromISO(c.create_at).toFormat('yyyy-MM-dd HH:mm') + " - " + c.from_booking.item.name;
    //         }).join("<br>");
    //     } else {
    //         return this.$t('booking.no_coupon');
    //     }
    // },
    priceLabel() {
      return this.booking ? "HK$" + (this.booking.fee) : "";

      // let couponAmount = 0;
      //
      // this.bookingRecord.used_coupons.forEach(function (c) {
      //     couponAmount += c.amount;
      // });
      //
      // return this.bookingRecord ? "$" + (this.bookingRecord.fee - couponAmount) : "";
    },
    statusLabel() {
      return this.$t(BOOKING_STATUS_LABEL[this.booking.status]);
    },
  },
  methods: {
    getBooking() {
      this.$callAPI('aafb/booking/', {booking_id: this.bookingId}, function (response) {
        this.booking = response.body.booking;
      });
    },
    cancelBooking() {
      if (confirm(this.$t('booking_detail.cancel_booking_warning'))) {
        this.$callAPI('aafb/cancel_booking/', {booking_id: this.booking.id}, function (response) {
          this.$router.back();
        });
      }
    },
  },
}
</script>

<style lang="less">
.booking-detail {
  padding: 30px;

  .booking-detail-content {
    background-color: white;
    padding: 2rem;

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-chevron-circle-left {
    font-size: 5em;
    cursor: pointer;
  }

  .confirm-message-label {
    text-align: left;
    line-height: 2.5em;
    font-size: 2em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 2.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;
    font-size: 1.2em;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }

  .accept-tnc {
    text-align: left;
    padding: 30px;
    font-size: 1.2em;
  }
}

.countdown {
  text-align: right;
}
</style>
